module.exports = __webpack_public_path__ + "static/media/Samurai_Davie_Menu.41088514.pdf";